const settings = {
	host: 'nocodb.4nol74.cloud',
}

export default settings
